var _rect, _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconText = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "var(--tool-color-dark)",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6513 0C23.4131 0 24 0.584184 24 1.30476V4.17523C24 4.8958 23.3824 5.47999 22.6207 5.47999C21.8589 5.47999 21.2414 4.8958 21.2414 4.17523V2.60952H14.8966V20.0707H9.10345V2.60952H2.75862V4.17523C2.75862 4.8958 2.14106 5.47999 1.37931 5.47999C0.617563 5.47999 0 4.8958 0 4.17523V1.30476C0 0.584184 0.648184 0 1.40993 0H22.6513Z",
    fill: "var(--tool-color-dark)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17702 21.5818C7.62623 21.6563 7.19995 22.1671 7.19995 22.7862C7.19995 23.4565 7.69975 23.9999 8.31623 23.9999H15.6837C16.3002 23.9999 16.8 23.4565 16.8 22.7862C16.8 22.1671 16.3737 21.6563 15.8229 21.5818H8.17702Z",
    fill: "var(--tool-color)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconText, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-text.38d60ec9.svg";
export { ForwardRef as ReactComponent };